import { useState } from "react";
import { C } from "./const";
import PersianClock from "./PersianClock";
import Logo from "./Logo";
import { UserData } from "../../types/user-data.type";
import { useNavigate } from "react-router-dom";

const IntroHeader = () => {
    const navigate = useNavigate();

    const [mobileOpen, setMobileOpen] = useState(false);
    const raw = localStorage.getItem("user");

    const userData: UserData = JSON.parse(raw ?? '{}');

    const onLogoutClicked = () => {
        localStorage.removeItem('user')
        navigate('/');
    }
    const list = [["خدمات", "/#services"],
    ["درباره ما", "/#about"],
    ["نظرات", "/#testimonials"],
    ["سوالات", "/#faq"],
    ["تماس", "/#contact"]]
    if (userData?.roles?.includes("Admin")) {
        list.push(["مدیریت بیمه نامه ها", "/admin/insurances"])
        list.push(["مدیریت کاربران", "/admin/users"])
    } else if (userData?.roles?.includes("Member")) {
        list.push(["جستجوی بیمه نامه", "/portal"])
    }
    const authButton = userData.userId ?
        <  >
            <label
                style={{ color: "rgba(255,255,255,.85)", fontSize: 14, fontWeight: 500 }}>
                {userData.name}
            </label>
            <button style={{
                background: C.accent,
                color: C.primaryDark,
                padding: "9px 22px",
                borderRadius: 8,
                fontWeight: 700,
                fontSize: 14,
            }}
                onClick={onLogoutClicked}
            >خروج</button>
        </> :
        <a
            href="/portal"
            className="hov-btn"
            style={{
                background: C.accent,
                color: C.primaryDark,
                padding: "9px 22px",
                borderRadius: 8,
                fontWeight: 700,
                fontSize: 14,
            }}
        >
            ورود به پورتال
        </a>

    return (
        <header
            style={{
                background: C.primaryDark,
                position: "sticky",
                top: 0,
                zIndex: 999,
                boxShadow: "0 2px 24px rgba(0,0,0,.2)",
            }}
        >
            <div
                style={{
                    maxWidth: 1200,
                    margin: "0 auto",
                    padding: "0 24px",
                    height: 100,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                {/* Logo */}
                <Logo style={{ display: "flex", alignItems: "center", gap: 10 }} />


                {/* Desktop links */}
                <nav
                    className="hide-mobile"
                    style={{ display: "flex", gap: 28, alignItems: "center" }}
                >
                    {list.map(([label, href]) => (
                        <a
                            key={label}
                            href={href}
                            className="hov-nav"
                            style={{ color: "rgba(255,255,255,.85)", fontSize: 14, fontWeight: 500 }}
                        >
                            {label}
                        </a>
                    ))}
                    <PersianClock style={{ color: "rgba(255,255,255,.85)", fontSize: 14, fontWeight: 500, direction: 'rtl' }}
                    ></PersianClock>
                    {authButton}
                </nav>

                {/* Mobile hamburger */}
                <button
                    className="show-mobile"
                    onClick={() => setMobileOpen(!mobileOpen)}
                    style={{
                        display: "none",
                        background: "none",
                        border: "none",
                        color: C.white,
                        fontSize: 26,
                        cursor: "pointer",
                        alignItems: "center",
                    }}
                >
                    {mobileOpen ? "✕" : "☰"}
                </button>
            </div>

            {/* Mobile drawer */}
            {mobileOpen && (
                <div
                    style={{
                        background: C.primary,
                        padding: "16px 24px 24px",
                        display: "flex",
                        flexDirection: "column",
                        gap: 18,
                    }}
                >
                    {list.map(([label, href]) => (
                        <a
                            key={label}
                            href={href}
                            onClick={() => setMobileOpen(false)}
                            style={{ color: C.white, fontSize: 15, fontWeight: 500 }}
                        >
                            {label}
                        </a>
                    ))}

                    <PersianClock style={{ color: "rgba(255,255,255,.85)", fontSize: 14, fontWeight: 500, direction: 'rtl' }}
                    ></PersianClock>
                    {authButton}
                </div>
            )}
        </header>
    );
}
export default IntroHeader;